import { IEntity, IEntityMapping, IExcelRow, IPropertyMapping, IPropertyUpdate } from '@/typings/import';
import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import { EEntityImportState, EEntityMatchType } from '../../enums';
import PropertyUpdateHelper from '../PropertyUpdateHelper';

export default class TransportationPermissionEntity implements IEntity<TransportationPermission> {
  entity?: TransportationPermission;
  matchedBy: EEntityMatchType;
  propertyUpdates: Array<IPropertyUpdate<TransportationPermission>>;
  excelRowIndex: number;
  selected: boolean;
  importState: EEntityImportState;

  constructor(
    row: IExcelRow,
    index: number,
    mapping: IEntityMapping<TransportationPermission>
  ) {
    const propertyUpdates = mapping.props.map(pm => {
      const propertyUpdate: IPropertyUpdate<TransportationPermission> = {
        propertyName: pm.propertyName,
        propertyType: pm.propertyType,
        rowKey: pm.cell ? pm.cell : '',
        oldValue: null,
        newValue: PropertyUpdateHelper.getNewValueFromMapping(pm, row),
        doNotUpdate: false,
        overrideValue: null,
        isValid: () => false,
      };
      propertyUpdate.isValid = this.getIsValid(propertyUpdate.propertyName, propertyUpdate.newValue);
      return propertyUpdate;
    });

    this.propertyUpdates = propertyUpdates;
    this.matchedBy = EEntityMatchType.Unknown;
    this.excelRowIndex = index;
    this.selected = false;
    this.importState = EEntityImportState.Mapped;
  }

  onMappingChanged(mapping: IEntityMapping<TransportationPermission>, row: IExcelRow) {
    mapping.props.forEach(p => {
      const propertyUpdate = this.propertyUpdates.find(pu => pu.propertyName === p.propertyName);
      if (propertyUpdate) {
        propertyUpdate.newValue = PropertyUpdateHelper.getNewValueFromMapping(p, row);
      }
    });
  }

  isValid(): boolean {
    return this.propertyUpdates.every(pu => pu.isValid());
  }

  private getIsValid(propertyName: string, value: object) {
    switch (propertyName) {
      default:
        return () => true;
    }
  }

  private getNewValue(propertyMapping: IPropertyMapping, row: IExcelRow) {
    if (propertyMapping.useStatic) {
      return propertyMapping.static;
    }
    if (propertyMapping.cell) {
      return row.excelRowData[propertyMapping.cell];
    }
    return null;
  }

}
